'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _SearchBar = require('components/SearchBar/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _StatisticsRecipientsList = require('containers/Statistics/StatisticsRecipientsList/StatisticsRecipientsList');

var _StatisticsRecipientsList2 = _interopRequireDefault(_StatisticsRecipientsList);

var _statistics2 = require('selectors/statistics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./StatisticsRecipients.scss');

var StatisticsRecipients = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadRecipients()).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    recipients: (0, _statistics2.getRecipients)(state),
    recipientsLoading: state.statistics.recipientsLoading
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(StatisticsRecipients, _Component);

  function StatisticsRecipients() {
    (0, _classCallCheck3.default)(this, StatisticsRecipients);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsRecipients.__proto__ || (0, _getPrototypeOf2.default)(StatisticsRecipients)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsRecipients, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.filter('');
    }
  }, {
    key: 'filter',
    value: function filter(kw) {
      this.props.filterRecipients(kw);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          recipients = _props.recipients,
          recipientsLoading = _props.recipientsLoading;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className) },
        _react2.default.createElement(
          'div',
          { className: styles.searchLine },
          _react2.default.createElement(_SearchBar2.default, {
            onChange: this.filter,
            inputClass: styles.searchInput
          }),
          _react2.default.createElement(
            'div',
            { className: styles.searchHint },
            t('You can search by name, email, recipient ID')
          )
        ),
        _react2.default.createElement(_StatisticsRecipientsList2.default, {
          className: styles.list,
          recipients: recipients,
          recipientsLoading: recipientsLoading
        })
      );
    }
  }]);
  return StatisticsRecipients;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  filterRecipients: _propTypes2.default.func,
  recipients: _propTypes2.default.array,
  recipientsLoading: _propTypes2.default.bool
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  recipients: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = StatisticsRecipients;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/StatisticsRecipients/StatisticsRecipients.js
// module id = 2223
// module chunks = 1